module.exports = __webpack_public_path__ + "img/circle3red.280e6f3e.png";